import { axios } from '@/utils/request'

const api = {
  cashOrderList: '/badminapi/order/cashOrderList',
  cashOrder: '/badminapi/order/cashOrder',
  getDownloadUrl: '/badminapi/order/getCashDownloadUrl',
  setCashColor:'/badminapi/order/setCashColor',
  setAllColor:'/badminapi/order/setAllColor', 

}

export default api
export function cashOrderList(parameter) {
  return axios({
    url: api.cashOrderList,
    method: 'get',
    params: parameter
  })
}

export function cashOrder(parameter) {
  return axios({
    url: api.cashOrder,
    method: 'get',
    params: parameter
  })
}

export function getDownloadUrl(parameter) {
  return axios({
    url: api.getDownloadUrl,
    method: 'get',
    params: parameter
  })
}

export function setCashColor(parameter) {
  return axios({
    url: api.setCashColor,
    method: 'post',
    params: parameter
  })
}
export function setAllColor(parameter) {
  return axios({
    url: api.setAllColor,
    method: 'post',
    params: parameter
  })
}
 
